import { Dialog } from "@headlessui/react";
import { CloseButton } from "./closeButton";
import Thumbnail from "./gallery/thumbnail";

const SearchLightbox = ({
  isOpen,
  closeModal,
  imageSrc,
  thumbnailSrc,
  ImageMetadataComponent,
  onSearchClick,
}: {
  isOpen: boolean;
  closeModal: () => void;
  imageSrc: string;
  thumbnailSrc: string;
  ImageMetadataComponent: React.ComponentType<{ imageSrc: string }>;
  onSearchClick: (imageSrc: string) => void;
}) => {
  const handleSearchSimilarImages = () => {
    onSearchClick(imageSrc);
    closeModal();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      className="fixed inset-0 z-[200] overflow-y-auto"
    >
      <div className="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0">
        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        <span
          className="hidden sm:inline-block sm:h-screen sm:align-middle"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div
          className="inline-block min-w-[800px] transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle"
          style={{ transform: "translateX(100px)" }}
        >
          <div className="mb-4 flex items-center justify-between">
            <Dialog.Title
              as="h3"
              className="text-lg font-medium leading-6 text-blue-500"
            >
              Image Details
            </Dialog.Title>
            <CloseButton handleClick={closeModal} className="ml-auto" />
          </div>
          <div className="flex min-w-[750px] gap-4">
            <div className="flex flex-grow">
              <a href={imageSrc} target={"_blank"} rel="noreferrer">
                <Thumbnail src={thumbnailSrc} className={"h-full w-full"} />
              </a>
            </div>
            <div className="flex min-w-[200px] max-w-[200px] flex-col justify-between break-words">
              <div>
                <ImageMetadataComponent imageSrc={imageSrc} />
              </div>
              <button
                className="mt-4 rounded-full bg-blue-100 p-2 text-white hover:bg-blue-700"
                onClick={handleSearchSimilarImages}
              >
                Search on Image
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SearchLightbox;
